/**
 * Copyright (c) 2021 Signant Health. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import { connect } from 'react-redux';

import { hideModal, showModal } from '../../actions/actions';
import { MODAL_TYPE_CHANGE_ANSWERS, MODAL_TYPE_CHANGE_ANSWERS_ADDENDUM } from '../../constants/modalTypes';
import { CHANGE_ANSWERS, CHANGE_ANSWERS_OPTIN_OPTOUT, VERSION } from '../../const';

import DocumentChangeStatusFillSoPOptInOptOutComponent from '../document_status/optinoptout/document.status.optinoptout.component';

import {
  extractOptInChoiceAnswers,
  extractOptInsOptOuts
} from '../document_status/optinoptout/document.status.optinoptout.container';

import {
  clearConsentDocuments4SoPChangeAnswers,
  fetchConsentDocument4SoPChangeAnswers,
  fetchConsentingOptInState4SoPChangeAnswers
} from '../../actions/changeAnswers4sop.actions';

const mapStateToProps = (state) => {
  const { isFetching, consentDocumentData, consentingOptInState, error: errorChangeAnswers } = state.changeAnswers;
  return {
    isLoading: isFetching,
    listOfOptInOptOut: extractOptInsOptOuts(consentDocumentData),
    consentingOptInState: consentingOptInState && extractOptInChoiceAnswers(consentingOptInState),
    error: errorChangeAnswers
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cancel: () => {
      dispatch(clearConsentDocuments4SoPChangeAnswers());
      dispatch(hideModal());
    },
    next: (props) => {
      const { consentName, consentVersion } = props;

      dispatch(
        showModal(MODAL_TYPE_CHANGE_ANSWERS_ADDENDUM, {
          shouldCloseOnOverlayClick: false,
          title: CHANGE_ANSWERS_OPTIN_OPTOUT,
          details: [consentName, '-', VERSION, consentVersion].join(' '),
          className: 'change-answers-addendum-modal',
          props: props
        })
      );
    },
    previous: (props) => {
      const { consentName, consentVersion } = props;

      dispatch(
        showModal(MODAL_TYPE_CHANGE_ANSWERS, {
          shouldCloseOnOverlayClick: false,
          title: CHANGE_ANSWERS,
          details: [consentName, '-', VERSION, consentVersion].join(' '),
          className: 'change-answers-date-reason-modal',
          props: props
        })
      );
    },

    loadDocumentOptInsOutsWithState: (consentGid, consentingGid) => {
      dispatch(fetchConsentingOptInState4SoPChangeAnswers(consentingGid));
      dispatch(fetchConsentDocument4SoPChangeAnswers(consentGid));
    }
  };
};

const ChangeAnswersOptInOptOutContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentChangeStatusFillSoPOptInOptOutComponent);

export { ChangeAnswersOptInOptOutContainer, mapStateToProps, mapDispatchToProps };

const ChangeAnswersOptInOptOutModal = (props) => {
  return (
    <div>
      <ChangeAnswersOptInOptOutContainer {...props} hasNext isChangeRequired />
    </div>
  );
};

export default ChangeAnswersOptInOptOutModal;
